(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bettine-brands"] && !Shopify.designMode) return;
  try {
    
(()=>{
function init(root){root.querySelectorAll('[data-brand-card]').forEach(card=>{
if(card.dataset.ready)return;card.dataset.ready='true';
const rotator=card.querySelector('.bettine-story-card__rotator'),front=card.querySelector('.bettine-story-card__front'),back=card.querySelector('.bettine-story-card__back'),close=card.querySelector('.bettine-story-card__close');

function resize(){rotator.style.height=card.classList.contains('is-open')?back.scrollHeight+'px':'';}
function setOpen(value,focus){card.classList.toggle('is-open',value);front.setAttribute('aria-expanded',String(value));front.inert=value;back.inert=!value;resize();if(focus)(value?close:front).focus();}
front.addEventListener('click',()=>{setOpen(true,true)});
close.addEventListener('click',()=>{setOpen(false,true)});
card.addEventListener('keydown',event=>{if(event.key==='Escape'){setOpen(false,true)}});
new ResizeObserver(()=>{if(card.classList.contains('is-open'))resize()}).observe(back);
window.addEventListener('resize',resize);
});}init(document);document.addEventListener('shopify:section:load',e=>init(e.target));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bettine-first-edit"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('bettine-first-edit'))customElements.define('bettine-first-edit',class extends HTMLElement{
connectedCallback(){this.track=this.querySelector('ul');this.root=this.closest('section');this.busy=false;this.paused=false;this.hovered=false;this.visible=false;this.motion=matchMedia('(prefers-reduced-motion: reduce)');this.abort=new AbortController();const signal=this.abort.signal;
this.root.querySelector('[data-edit-next]').addEventListener('click',()=>this.move(1),{signal});this.root.querySelector('[data-edit-prev]').addEventListener('click',()=>this.move(-1),{signal});const pause=this.root.querySelector('[data-edit-pause]');pause.addEventListener('click',()=>{this.paused=!this.paused;pause.setAttribute('aria-pressed',String(this.paused));pause.setAttribute('aria-label',this.paused?this.dataset.playLabel:this.dataset.pauseLabel);pause.textContent=this.paused?'▶':'Ⅱ';},{signal});
this.root.addEventListener('pointerenter',e=>{if(e.pointerType==='mouse')this.hovered=true},{signal});this.root.addEventListener('pointerleave',()=>this.hovered=false,{signal});this.addEventListener('pointerdown',e=>{this.startX=e.clientX;this.startY=e.clientY},{signal});this.addEventListener('pointerup',e=>{const dx=e.clientX-this.startX,dy=e.clientY-this.startY;if(Math.abs(dx)>45&&Math.abs(dx)>Math.abs(dy)){this.suppressClick=true;this.move(dx<0?1:-1)}},{signal});this.addEventListener('click',e=>{if(this.suppressClick){e.preventDefault();e.stopPropagation();this.suppressClick=false}},{signal,capture:true});
this.observer=new IntersectionObserver(entries=>this.visible=entries[0].isIntersecting,{threshold:.3});this.observer.observe(this);this.timer=setInterval(()=>{if(!this.paused&&!this.hovered&&this.visible&&!document.hidden&&!this.motion.matches&&!this.root.contains(document.activeElement))this.move(1)},4500);this.update();this.resize=new ResizeObserver(()=>this.update());this.resize.observe(this);}
update(){const bound=this.getBoundingClientRect();Array.from(this.track.children).forEach(item=>{const r=item.getBoundingClientRect();item.inert=r.left<bound.left-2||r.right>bound.right+2;});}
async move(direction){if(this.busy||this.track.children.length<2)return;this.busy=true;const first=this.track.firstElementChild;const step=first.getBoundingClientRect().width+parseFloat(getComputedStyle(this.track).gap);if(direction<0)this.track.prepend(this.track.lastElementChild);Array.from(this.track.children).forEach(item=>item.inert=false);const from=direction>0?0:-step,to=direction>0?-step:0;const animation=this.track.animate([{transform:`translateX(${from}px)`},{transform:`translateX(${to}px)`}],{duration:this.motion.matches?0:650,easing:'cubic-bezier(.22,.61,.36,1)',fill:'forwards'});try{await animation.finished;if(direction>0)this.track.append(first);}finally{animation.cancel();this.busy=false;this.update();}}
disconnectedCallback(){clearInterval(this.timer);this.abort?.abort();this.observer?.disconnect();this.resize?.disconnect();}
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
